import useAuthHasUserClass from '@apps/www/src/www/hooks/useAuthHasUserClass';
import useUIState from '@apps/www/src/www/hooks/useUIState';

import { UIStateKeys } from '@apps/www/src/www/hooks/useUIState';
import UserClass from '@pkgs/shared/enums/UserClass';

export default function useShowModeratorControls() {
	const isModerator = useAuthHasUserClass(UserClass.MODERATOR);
	const [showModeratorControls] = useUIState(UIStateKeys.SHOW_MODERATOR_CONTROLS);

	return isModerator && showModeratorControls;
}
